import { render } from "./ViewSchool.vue?vue&type=template&id=55e2bd0b"
import script from "./ViewSchool.vue?vue&type=script&lang=js"
export * from "./ViewSchool.vue?vue&type=script&lang=js"

import "./ViewSchool.vue?vue&type=style&index=0&id=55e2bd0b&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__